import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Row, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { parseDate } from 'helpers/utils';
import Flex from 'components/common/Flex';
import { dataCursosById } from 'data/apiConection.js/dataCursos';

const Notes = ({ alumno , notasAlumno = [], onDelete }) => {
  const [ curso , setCurso ] = useState('');
  useEffect(() => {
    if (alumno && alumno.curso_id) {
      const fetchCurso = async () => {
        try {
          const cu = await dataCursosById(alumno.curso_id);
          console.log(cu);
          setCurso(cu);
        } catch (error) {
          console.error("Error fetching curso by id!", error.message);
        }
      };
      fetchCurso();
    }
  }, [alumno?.curso_id]);
  return (
    <Flex direction="column" className="gap-3">
      {notasAlumno.map((nota, index) => {
        const { subject, grade, observations, created_at , id } = nota;
        return (
          <div
            key={index}
            className="bg-white dark__bg-1100 p-x1 rounded-3 shadow-sm position-relative"
          >
            {/* Delete Button */}
            <Button
              variant="danger"
              size="sm"
              className="position-absolute top-0 end-0 m-2"
              onClick={() => onDelete(id)}
            >
              <FontAwesomeIcon icon="trash-alt" />
            </Button>

            <Row className="flex-between-center">
            <Col
              xs={12}
              md={7}
              xl={12}
              xxl={8} 
              className="order-1 order-md-0 order-xl-1 order-xxl-0"
            >
              <h5 className="mb-0 border-top border-md-0 border-xl-top border-xxl-0 mt-x1 mt-md-0 mt-xl-x1 mt-xxl-0 pt-x1 pt-md-0 pt-xl-x1 pt-xxl-0 border-200 border-xl-200">
                {curso.nivel === "KINDER" || curso.nivel === "PREPARATORIO 1" || curso.nivel === "PREPARATORIO 2" ? (
                (grade>=8) && `${subject} : Sobresaliente` || (grade>7 && grade<8  ) && `${subject}:Muy Bien` || (grade<=7) && `${subject} : Bien`
                ) : (
              `${subject} ${grade}`
              )}
              </h5>
            </Col>

              <Col
                xs={12}
                md="auto"
                xl={12}
                xxl="auto"
                className="d-flex flex-between-center"
              >
                <Dropdown
                  align="end"
                  className="btn-reveal-trigger d-inline-block"
                >
                  <Dropdown.Menu className="border py-0">
                    <div className="py-2">
                      <Dropdown.Item>View</Dropdown.Item>
                      <Dropdown.Item>Export</Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item className="text-danger">
                        Remove
                      </Dropdown.Item>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <h6 className="mb-0 mt-2">
              <FontAwesomeIcon icon="clock" className="text-primary me-2" />
              <span className="text-600">{parseDate(created_at)}</span>
            </h6>
            <p className="w-lg-75 w-xl-100 w-xxl-75 mb-0 border-top border-md-0 border-xl-top border-xxl-0 mt-x1 mt-md-4 mt-xl-x1 mt-xxl-4 pt-x1 pt-md-0 pt-xl-x1 pt-xxl-0 border-200 border-xl-200">
              {observations}
            </p>
          </div>
        );
      })}
    </Flex>
  );
};

Notes.propTypes = {
  notasAlumno: PropTypes.arrayOf(
    PropTypes.shape({
      subject: PropTypes.string.isRequired,
      grade: PropTypes.string.isRequired,
      observations: PropTypes.string,
      created_at: PropTypes.string.isRequired,
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
  alumno: PropTypes.object,
};

export default Notes;

